"use strict";

var _toConsumableArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var Toast_1 = tslib_1.__importDefault(require("./Toast"));

function ToastContainer(_ref) {
  var newToastOption = _ref.newToastOption;

  var _react_1$useState = react_1.useState([]),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      toasts = _react_1$useState2[0],
      setToasts = _react_1$useState2[1];

  var updateToastItems = function updateToastItems() {
    if (newToastOption) {
      setToasts([].concat(_toConsumableArray(toasts), [newToastOption]));
    }
  };

  react_1.useEffect(updateToastItems, [newToastOption]);
  return jsx_runtime_1.jsx(react_1.Fragment, {
    children: toasts.map(function (_a) {
      var id = _a.id,
          props = tslib_1.__rest(_a, ["id"]);

      return jsx_runtime_1.jsx(Toast_1.default, Object.assign({
        insertToBody: false
      }, props), id);
    })
  }, void 0);
}

exports.default = ToastContainer;